import React from "react";
import Navbar from "../components/Navbar/Navbar";
import Hero from "../components/Hero/Hero";
import Categories from "../components/Categories/Categories";
import Features from "../components/Features/Features";
import HowItWorks from "../components/HowItWorks/HowItWorks";
import Listings from "../components/Listings/Listings";
import Pricing from "../components/Pricing/Pricing";
import FAQ from "../components/FAQ/FAQ";
import Download from "../components/Download/Download";
import Footer from "../components/Footer/Footer";

const components = {
  Navbar,
  Hero,
  Categories,
  Features,
  HowItWorks,
  Listings,
  Pricing,
  FAQ,
  Download,
  Footer,
};

function HomePage() {
  return (
    <>
      <Navbar />
      <main>
        <Hero />
        <Listings />
        <Categories />
        <HowItWorks />
        <Features />
        <Pricing />
        <FAQ />
        <Download />
      </main>
      <Footer />
    </>
  );
}

export default HomePage;
